import { coerceNumberProperty } from '@angular/cdk/coercion';
import { SelectOptions } from '@cbuild/controls';

// tslint:disable: no-any
export function enumToSelectOptions<T = any>(
  ref: any,
  type: 'number' | 'string' = 'number'
): SelectOptions<T> {
  return Object.keys(ref)
    .filter(k => typeof ref[k] === type)
    .map(key => ({
      label: type === 'string' ? ref[key] : key,
      value: ref[key]
    }));
}

export function enumMapToSelectOptions(
  ref: any,
  type: 'number' | 'string' = 'number'
): SelectOptions {
  return Object.keys(ref).map(key => ({
    label: ref[key],
    value:
      typeof key === 'number' && type === 'number'
        ? coerceNumberProperty(key)
        : key
  }));
}
